import { useState, useMemo } from 'react';


export type LoadFn<ResultT> = (
  asyncAction: () => Promise<ResultT>,
  loadText?: string
) => Promise<{
  result: ResultT | null,
  error: Error | null
}>

/** Hook for managing loading/error states in fetching/requesting something.
 */
function useLoader<ResultT = any>(initialState?: boolean | string): [
  boolean | string | undefined,
  string | undefined,
  LoadFn<ResultT>
]{
  const [loading, setLoading] = useState<boolean | string | undefined>(initialState);
  const [error, setError] = useState<string>();

  const loadFn = useMemo(() => async (asyncAction: () => Promise<ResultT>, loadText?: string) => {
    setLoading(loadText || true);
    setError(undefined);

    try {
      const result = await asyncAction();
      setLoading(false);
      return {result, error: null};
  } catch(e){
      setError((e as Error).message);
      setLoading(false);
      return {result: null, error: e as Error};
    }
  }, []);
    
  return [loading, error, loadFn];
}

export default useLoader;
